/*
 * @Author: 李朋飞
 * @Date: 2021-07-15 19:02:12
 * @LastEditTime: 2021-09-06 10:33:40
 * @Description: 
 * commit 用于执行mutation内的方法
 * state: state 数据
 * product： 执行方法实际接收到的参数
 * 
 * 可以再里面通过判断来决定执行具体哪个mutation
 * 
 * 使用
 * import { mapActions } from 'vuex';
 * 
 * methods: {
 *    ...mapActions(['ActionsSetLogo']),
 *    this.ActionsSetLogo(product)
 * }
 */

import Vue from "vue";
import * as types from './mutation-types';


export const get_menu_list = function ({ commit }, menuList) {
  commit(types.GET_MEN_LIST, menuList);
}
export const router_list_new = function ({ commit }, routerListNew) {
  commit(types.ROUTER_LIST_NEW, routerListNew);
}

function isJSON(str) {
  try {
    JSON.parse(str);
    return true;
  } catch (e) {
    return false;
  }
}

export const get_message_list = function ({ commit, state }, { userId, end = undefined, history_at = '' }) {
  // 如果本地有100条，取本地的，否则取历史的，如果取历史的，要保存到本地
  let messageList = state.historyMessage;
  let accidArr = [];
  Vue.prototype.nim.getLocalMsgs({
    sessionId: 'team-' + userId,
    limit: 100,
    // end: 0,
    end: end ? end.time : 0,
    types: ['custom', 'text', 'image', 'audio', 'video', 'file', 'tip'],
    done(err, obj) {
      if ((obj.msgs.length < 100)) {
        Vue.prototype.nim.getHistoryMsgs({
          scene: "team",
          to: userId,
          asc: false,
          limit: 100,
          // beginTime: 0,
          // endTime: 0,
          beginTime: history_at || 0,
          endTime: end ? end.time : 0,
          lastMsgId: end ? end.idServer : undefined,
          msgTypes: ['custom', 'text', 'image', 'audio', 'video', 'file', 'tip'],
          reverse: true,
          done(err1, obj1) {
            // if (obj1.msgs.length < 100) {
            //   commit(types.UPDATE_SESSION_FINISHED, userId);
            // }
            let arr = (obj1.msgs || []).filter(msg => {
              if ((msg.flow == 'in') && (msg.type == "custom") && isJSON(msg.content)) {
                const content = JSON.parse(msg.content);
                return !(content && ((content.custom_type == 'DeleteTeamUser') || (content.custom_type == 'AddTeamUser')));
              }
              return true;
            })
            Vue.prototype.nim.saveMsgsToLocal({
              msgs: arr,
              done(err2, obj2) {
                console.log('历史消息保存到本地', err2, obj2)
              }
            });
            arr.forEach((item) => {
              item.isRead = true;
              if (item.fromClientType != 'Server') {
                accidArr.push(item.from);
              }
              // 群用户accid
              accidArr = accidArr.filter((item, index) => accidArr.indexOf(item) === index);
              if (item.type == "file" || item.type == "image") {
                item.file = [item.file];
              } else if ((item.type == "custom") && item.content) {
                item.content = isJSON(item.content) ? JSON.parse(item.content) : {};
              }
            });
            // 获取用户资料
            Vue.prototype.nim.getUsers({
              accounts: accidArr,
              done: getUsersDone
            });
            function getUsersDone(error, users) {
              console.log('获取用户资料数组' + (!error ? '成功' : '失败'), users);
              if (!error) {
                arr.forEach(item => {
                  users.forEach(userItem => {
                    if (item.from == userItem.account) {
                      item.avatar = userItem.avatar;
                    }
                  })
                })
                if (end) {
                  messageList.unshift(...arr);
                } else {
                  messageList = arr;
                }
                console.log('集成历史消息列表', { userId, end, history_at, }, messageList)
                commit(types.HISTORY_MESSAGE, messageList);
              }
            }
          },
        })
      } else {
        let arr = obj.msgs.reverse();
        arr.forEach((item) => {
          item.isRead = true;
          if (item.fromClientType != 'Server') {
            accidArr.push(item.from);
          }
          // 群用户accid
          accidArr = accidArr.filter((item, index) => accidArr.indexOf(item) === index);
          if (item.type == "file" || item.type == "image") {
            item.file = [item.file];
          } else if ((item.type == "custom") && item.content) {
            item.content = isJSON(item.content) ? JSON.parse(item.content) : {};
          }
        });
        // 获取用户资料
        Vue.prototype.nim.getUsers({
          accounts: accidArr,
          done: getUsersDone
        });
        function getUsersDone(error, users) {
          console.log('获取用户资料数组' + (!error ? '成功' : '失败'), users);
          if (!error) {
            arr.forEach(item => {
              users.forEach(userItem => {
                if (item.from == userItem.account) {
                  item.avatar = userItem.avatar;
                }
              })
            })
            if (end) {
              messageList.unshift(...arr);
            } else {
              messageList = arr;
            }
            console.log('集成本地消息列表', { userId, end, history_at, }, messageList)
            commit(types.HISTORY_MESSAGE, messageList);
          }
        }
      }
    }
  })
}


// WEBPACK FOOTER //
// ./src/store/actions.js